import type { IncidentStatus } from '@prerender/diagnostics-api';

export const INCIDENT_STATUS_LABELS: Record<IncidentStatus, string> = {
  active: 'Active',
  monitoring: 'Monitoring',
  closed: 'Closed',
};

export function incidentStatusLabel(status: IncidentStatus): string {
  return INCIDENT_STATUS_LABELS[status];
}
